import { secondsToHHMMSS } from '@helpers/secondsToHHMMSS';
import bytes from 'bytes';
import type { TFileWithMeta } from '../../UploadProvider/types/TFileWithMeta';
import { shouldShowDurationInFilePreview } from './shouldShowDurationInFilePreview';

export const makeSubtitle = (meta: TFileWithMeta['meta']) => {
  const sizeText = meta.size && meta.size > 0 ? ` (${bytes(meta.size)})` : '';
  const dur =
    shouldShowDurationInFilePreview(meta) &&
    meta.extra?.duration != null &&
    Number.isFinite(meta.extra?.duration) &&
    meta.extra.duration > 0
      ? ` • ${secondsToHHMMSS(meta.extra.duration)}`
      : '';
  if (meta.status === 'uploading') {
    return `Uploading... ${Math.round(meta.percent || 0)}%`;
  }
  if (meta.status === 'error') {
    return meta.errorMessage || 'Upload error';
  }
  if (meta.extra?.analysisStatus === 'progress') {
    return `Analyzing...${sizeText}`;
  }
  if (meta.status === 'done' && meta.extra?.jobId && !meta.extra?.analysisStatus && !meta.extra?.mediaId) {
    return `Analyzing...${sizeText}`;
  }
  if (meta.extra?.analysisStatus === 'error') {
    return `Error${sizeText}`;
  }
  if (meta.status === 'done') {
    return `Uploaded${dur}${sizeText}`;
  }
  if (meta.status === 'external') {
    return `Saved${dur}${sizeText}`;
  }
  if (meta.status === 'queued') {
    return `Ready${dur}${sizeText}`;
  }
  if (meta.status === 'preparing') {
    return 'Preparing...';
  }
  return '';
};
